export default {
  install (Vue) {
    Vue.mixin({
      data: () => ({
        animationDelayTimeout: null,
        animationDelay: 0
      }),

      methods: {
        updateDelay () {
          if (this.animationDelay < 60) {
            this.animationDelay += 0.1
            this.animationDelayTimeout = setTimeout(this.updateDelay, 100)
          } else {
            clearTimeout(this.animationDelayTimeout)
          }
        }
      },

      mounted () {
        this.animationDelayTimeout = setTimeout(this.updateDelay, 100)
      }
    })
  }
}
